var _clipPath, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 100"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ticket_svg__a",
    x1: "0%",
    x2: "0%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffca28",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#ffb300",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ff9800",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ticket_svg__b",
    x1: "0%",
    x2: "0%",
    y1: "0%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffb300",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    style: {
      stopColor: "#fff176",
      stopOpacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#fffde7",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    style: {
      stopColor: "#fff176",
      stopOpacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ffb300",
      stopOpacity: 0
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "Ticket_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 0h500v25a25 25 0 0 0 0 50v25H50V75a25 25 0 0 0 0-50z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ticket_svg__a)",
    d: "M50 0h500v25a25 25 0 0 0 0 50v25H50V75a25 25 0 0 0 0-50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ticket_svg__b)",
    d: "M156 0h288v100H156z",
    clipPath: "url(#Ticket_svg__c)"
  })));
};
export default SvgTicket;